import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import AppView from './views/AppView';

const intervalMS = 30 * 60 * 1000; //30 minutes

const ViewApp = () => {
    const {
        offlineReady: [offlineReady],
        needRefresh: [needRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(swUrl, r) {
            if (!r) return

            setInterval(async () => {
                if (!(!r.installing && navigator))
                    return

                if (('connection' in navigator) && !navigator.onLine)
                    return

                const resp = await fetch(swUrl, {
                    cache: 'no-store',
                    headers: {
                        'cache': 'no-store',
                        'cache-control': 'no-cache',
                    },
                })

                if (resp?.status === 200)
                    await r.update()
            }, intervalMS)
        }
    });

    useEffect(() => {
        if (offlineReady) {
            console.log("PWA Offline Ready");
        } else if (needRefresh) {
            console.log("PWS Needs Refresh");
            updateServiceWorker(true);
        }
    }, [needRefresh, offlineReady, updateServiceWorker]);

    return <AppView />
};

export default ViewApp;
